import withT from "neetocommons/react-utils/withT";
import { Typography } from "neetoui";
import PropTypes from "prop-types";

const PublishYourItem = withT(({ t, item, description }) => (
  <div className="relative mx-auto flex max-w-sm flex-col gap-y-3">
    <Typography
      className="pt-6 text-center"
      data-testid="publish-your-item-header"
      style="h2"
      weight="semibold"
    >
      <span className="relative inline-flex flex-col-reverse items-center gap-6 whitespace-nowrap">
        {t("neetoMolecules.publishYourItem.title", { item })}
        <svg
          className="bottom-0 start-full sm:absolute sm:ms-2"
          fill="none"
          height="53"
          viewBox="0 0 58 53"
          width="58"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.31443 51.7732C12.2565 52.0622 16.7513 49.6192 20.5942 46.7584C23.9346 44.2309 26.9993 41.3397 29.7741 38.2342C35.221 32.0755 39.4754 24.8436 42.2528 17.0968C43.808 12.7381 44.9292 8.18667 45.4884 3.57236C45.6449 2.40707 43.8096 2.20391 43.6892 3.36379C42.7055 11.2831 40.1442 18.9973 36.2536 25.9536C32.3935 32.8685 27.251 39.092 21.0745 44.0712C17.2642 47.1481 12.6506 50.2719 7.523 49.974C7.03852 49.9362 6.57212 50.2641 6.49837 50.754C6.46065 51.2385 6.82995 51.7355 7.31443 51.7732Z"
            fill="#68737D"
          />
          <path
            d="M30.2178 13.9691C33.8174 10.9607 37.4585 7.98292 41.0582 4.97452C41.4831 4.61603 41.8775 4.29898 42.3025 3.9405C42.6968 3.62344 43.0749 3.19834 43.5576 2.97852C44.1735 2.66502 44.6058 3.3367 44.8671 3.84994C45.9733 5.82004 46.9462 7.88381 47.9912 9.93677C49.193 12.2977 50.4307 14.6532 51.6325 17.0141C52.155 18.0405 53.8496 17.3072 53.2911 16.2861C52.1416 14.0279 50.9921 11.7696 49.8066 9.51679C48.7093 7.36119 47.6787 5.15873 46.4788 3.05538C45.9834 2.209 45.3385 1.34824 44.3479 1.12871C43.1303 0.869604 42.1471 1.68026 41.2972 2.39723C39.3974 3.97169 37.4977 5.54615 35.5979 7.12061C33.401 8.92386 31.2401 10.7217 29.0486 12.561C28.1627 13.2833 29.2958 14.6969 30.2178 13.9691Z"
            fill="#68737D"
          />
        </svg>
      </span>
    </Typography>
    <Typography
      className="neeto-ui-text-gray-700 w-full text-center"
      data-testid="publish-your-item-description"
      style="body2"
    >
      {description}
    </Typography>
  </div>
));

PublishYourItem.propTypes = {
  /**
   * Item that need to be published
   */
  item: PropTypes.string,
  /**
   * Description to display on component
   */
  description: PropTypes.string,
};

export default PublishYourItem;
